// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"pagecard_cardBody__PDNG9"};